module.exports = __webpack_public_path__ + "static/media/PM_LGHealth_RGB_535x90_WebsiteVersionLogo.f3933987.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PM_LGHealth_RGB_535x90_WebsiteVersionLogo.png
// module id = 361
// module chunks = 0